import { Button, ButtonSize, ButtonVariant, CmhcIcon, CmhcIconSize } from '@cmhc-schl/hearth-ui';
import React, { memo, useState } from 'react';
import styles from '../styles.module.scss';
import { Box, Stack } from '@mui/material';

interface CopyContentToClipBoardProps {
  children: React.ReactNode;
  clipboardContent: string;
  showClipButton?: boolean;
  onSuccess?: () => void;
}

const CopyContentToClipBoard = ({
  children,
  clipboardContent,
  showClipButton = true,
  onSuccess
}: CopyContentToClipBoardProps) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(clipboardContent)
      .then(onSuccess)
      .catch((err) => {});
  };

  return (
    <Stack direction="row" className={styles.CopyContentToClipBoard}>
      <Box>{children}</Box>
      <Box className={styles.CopyContentToClipBoardButtonContainer}>
        {showClipButton && (
          <Button
            size={ButtonSize.SMALL}
            variant={ButtonVariant.TERTIARY}
            leadingIcon={() => <CmhcIcon size={CmhcIconSize.MEDIUM} type="icon_container" />}
            onClick={handleCopy}
            className={styles.copyButton}
            name="copyButton"
            text={{ value: ' ' }}
          />
        )}
      </Box>
    </Stack>
  );
};

export default memo(CopyContentToClipBoard);
